export enum Permission {
  MarketingAgentViewAccess = 'marketing_agent.view',
  //MarketingAgentModifyAccess = 'marketing_agent.modify',
  RestaurantCampaignViewAccess = 'restaurant_campaign.view',
  RestaurantCampaignModifyAccess = 'restaurant_campaign.modify',
  RetailerFundedMarketingRetailerFundedMarketingViewAccess = 'retailer_funded_marketing_retailer_funded_marketing.view',
  RetailerFundedMarketingRetailerFundedMarketingModifyAccess = 'retailer_funded_marketing_retailer_funded_marketing.modify',
  RetailerFundedMarketingRetailerFundedMarketingAdminAccess = 'retailer_funded_marketing_retailer_funded_marketing.admin',
  //RetailerFundedMarketingBillingView = 'retailer_funded_marketing_billing.view',
  //RetailerFundedMarketingBillingModifyAccess = 'retailer_funded_marketing_billing.modify',
  RetailerFundedMarketingRetailerFundedMarketingInsights = 'retailer_funded_marketing_retailer_funded_marketing.insights',
  RetailerFundedMarketingCRMCampaignsView = 'retailer_funded_marketing_crm_campaigns.view',
  RetailerFundedMarketingCRMCampaignsModify = 'retailer_funded_marketing_crm_campaigns.modify',
  RetailerFundedMarketingCRMCampaignsManualCRMAccess = 'retailer_funded_marketing_crm_campaigns.manual_crm',
  RouletteApiAccessView = 'roulette_api_access.view',
  RetailerFundedMarketingToolingPermissiveMode = 'retailer_funded_marketing.tooling_permissive_mode',
  OffersToolingAdminAccess = 'offers_tooling.admin',
  OffersToolingModifyAccess = 'offers_tooling.modify',
  OffersToolingViewAccess = 'offers_tooling.view',
  OffersToolingApproverPermissionHighRisk = 'offers_tooling.approver_permission_high_risk',
}
